/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Open_Not_In_PlanInputs */

const en_us2_workout_open_not_in_plan = /** @type {(inputs: Workout_Open_Not_In_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is not in your current plan, so it can only be continued on the device that started it.`)
};

const pt_br2_workout_open_not_in_plan = /** @type {(inputs: Workout_Open_Not_In_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ele não está no seu plano atual, então só dá para continuar no aparelho em que começou.`)
};

const es_419_workout_open_not_in_plan = /** @type {(inputs: Workout_Open_Not_In_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No está en tu plan actual, así que solo se puede continuar en el dispositivo donde empezó.`)
};

const pt_pt2_workout_open_not_in_plan = /** @type {(inputs: Workout_Open_Not_In_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não está no teu plano atual, por isso só pode ser continuado no dispositivo onde começou.`)
};

const fr_fr2_workout_open_not_in_plan = /** @type {(inputs: Workout_Open_Not_In_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elle ne fait pas partie de ton programme actuel, elle ne peut donc continuer que sur l'appareil qui l'a commencée.`)
};

const de_de2_workout_open_not_in_plan = /** @type {(inputs: Workout_Open_Not_In_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist nicht in deinem aktuellen Plan und kann daher nur auf dem Gerät fortgesetzt werden, auf dem es gestartet wurde.`)
};

const it_it2_workout_open_not_in_plan = /** @type {(inputs: Workout_Open_Not_In_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è nella tua scheda attuale, quindi si può continuare solo sul dispositivo dove è iniziato.`)
};

/**
* | output |
* | --- |
* | "It is not in your current plan, so it can only be continued on the device that started it." |
*
* @param {Workout_Open_Not_In_PlanInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_open_not_in_plan = /** @type {((inputs?: Workout_Open_Not_In_PlanInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Open_Not_In_PlanInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_open_not_in_plan(inputs)
	if (locale === "es-419") return es_419_workout_open_not_in_plan(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_open_not_in_plan(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_open_not_in_plan(inputs)
	if (locale === "de-DE") return de_de2_workout_open_not_in_plan(inputs)
	if (locale === "it-IT") return it_it2_workout_open_not_in_plan(inputs)
	return en_us2_workout_open_not_in_plan(inputs)
});
export { workout_open_not_in_plan as "workout.open_not_in_plan" }